import { render, staticRenderFns } from "./delivery-address-name.vue?vue&type=template&id=2f7f2088&"
import script from "./delivery-address-name.vue?vue&type=script&lang=js&"
export * from "./delivery-address-name.vue?vue&type=script&lang=js&"
import style0 from "./delivery-address-name.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7f2088')) {
      api.createRecord('2f7f2088', component.options)
    } else {
      api.reload('2f7f2088', component.options)
    }
    module.hot.accept("./delivery-address-name.vue?vue&type=template&id=2f7f2088&", function () {
      api.rerender('2f7f2088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/delivery-address-name.vue"
export default component.exports